// Enhanced Loteria deck — 54 figures in standard Loteria order (1-54).
// Served as static frontend assets from /loteria/*.webp so the browser/CDN
// caches them naturally (the /api/* ingress strips long Cache-Control, which
// made proxy-fetching ~165MB on every page load).
// Compact WebP @ 640px ~= 2.5MB total deck (down from ~165MB raw PNG).
const NAMES = [
  "El Gallo", "El Diablito", "La Dama", "El Catrín", "El Paraguas",
  "La Sirena", "La Escalera", "La Botella", "El Barril", "El Árbol",
  "El Melón", "El Valiente", "El Gorrito", "La Muerte", "La Pera",
  "La Bandera", "El Bandolón", "El Violoncello", "La Garza", "El Pájaro",
  "La Mano", "La Bota", "La Luna", "El Cotorro", "El Borracho",
  "El Negrito", "El Corazón", "La Sandía", "El Tambor", "El Camarón",
  "Las Jaras", "El Músico", "La Araña", "El Soldado", "La Estrella",
  "El Cazo", "El Mundo", "El Apache", "El Nopal", "El Alacrán",
  "La Rosa", "La Calavera", "La Campana", "El Cantarito", "El Venado",
  "El Sol", "La Corona", "La Chalupa", "El Pino", "El Pescado",
  "La Palma", "La Maceta", "El Arpa", "La Rana",
];

export const ENHANCED_LOTERIA_FIGURES = NAMES.map((name, i) => {
  const n = String(i + 1).padStart(2, "0");
  return { id: `enh-${n}`, name, src: `/loteria/enh-${n}.webp` };
});
